import type { ReactNode } from 'react';

/** `inputClass` without its corners, for controls joined to an addon. */
export const inputBaseClass =
  'w-full border border-input-border bg-white px-3 py-2 text-sm leading-tight text-ink-soft placeholder:text-placeholder focus:border-input-focus focus:outline-none disabled:bg-line aria-[invalid=true]:border-danger';

/** The legacy `.form-control`: thin translucent border, blue border on focus, no ring. */
export const inputClass = `${inputBaseClass} rounded-bs`;

/** A form label (`.form-control-label`). */
export const labelClass = 'mb-2 inline-block font-normal text-ink';

/** A field's error message (`.form-control-feedback`). */
export const errorClass = 'mt-1 text-sm text-danger';

/** One `.input-group-addon` box, for text or an `Icon`. */
export const inputAddonClass =
  'flex min-w-10 items-center justify-center border border-input-border bg-line px-3 py-2 text-sm leading-tight text-ink-soft';

/**
 * A control with addon boxes joined to its left and/or right (`.input-group`): `%`, `DKK`, `.00`,
 * `@`, a lock or a search icon. The child is the control itself (typically `className={inputClass}`).
 */
export function InputGroup({
  before,
  after,
  className = '',
  children,
}: {
  before?: ReactNode;
  after?: ReactNode;
  className?: string;
  children: ReactNode;
}) {
  return (
    <div
      className={`flex w-full items-stretch [&>*]:rounded-none [&>*+*]:-ml-px [&>:first-child]:rounded-l-bs [&>:last-child]:rounded-r-bs [&>input,&>select]:min-w-0 [&>input,&>select]:flex-1 [&>input:focus,&>select:focus]:z-10 ${className}`}
    >
      {before !== undefined ? <span className={inputAddonClass}>{before}</span> : null}
      {children}
      {after !== undefined ? <span className={inputAddonClass}>{after}</span> : null}
    </div>
  );
}
